export default __webpack_public_path__ + "static/media/banner_img2.765d481c.webp";